import { Link, Typography, alpha } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import { getUserCanEditPropertyCatalog } from 'entities/User/model/selectors/userPermissionsSeletors';
import { useMarketplaceNavigation } from 'features/SearchCatalogItems/lib/hooks/useMarketplaceNavigation';
import openBoxSearch from 'shared/assets/svg/open-box-search.svg';
import { EmptyPlaceholder } from 'shared/ui/EmptyPlaceholder/EmptyPlaceholder';

interface InventoryTableEmptyProps {
    isActiveSearch: boolean;
    isOrdersAddItemsFlow?: boolean;
}

export const InventoryTableEmpty = ({
    isActiveSearch,
    isOrdersAddItemsFlow = false,
}: InventoryTableEmptyProps) => {
    const { t } = useTranslation();

    const canEditCatalog = useSelector(getUserCanEditPropertyCatalog);
    const { navigateToMarketplace } = useMarketplaceNavigation(
        'property-catalog',
        isOrdersAddItemsFlow,
    );

    return (
        <EmptyPlaceholder
            image={openBoxSearch}
            childrenContainerSx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            {isActiveSearch ? (
                <>
                    <Typography
                        color={(theme) =>
                            alpha(theme.palette.common.black, 0.5)
                        }
                        typography="openSans.body2Medium"
                        sx={{
                            maxWidth: '280px',
                            textAlign: 'center',
                            marginBottom: '16px',
                        }}
                    >
                        {t('No items found in the inventory list')}.
                    </Typography>
                    {canEditCatalog && (
                        <Link
                            data-testid="search-property-catalog-link"
                            component="button"
                            typography="openSans.body2Medium"
                            sx={{
                                lineHeight: '24px',
                                textAlign: 'center',
                                cursor: 'pointer',
                            }}
                            underline="hover"
                            onClick={navigateToMarketplace}
                        >
                            {t('Search the Property Catalog')}.
                        </Link>
                    )}
                </>
            ) : (
                <>
                    <Typography
                        color={(theme) =>
                            alpha(theme.palette.common.black, 0.5)
                        }
                        typography="openSans.body2Medium"
                        sx={{
                            maxWidth: '280px',
                            textAlign: 'center',
                            marginBottom: '8px',
                        }}
                    >
                        {t('There are no Items in the Inventory')}.
                    </Typography>
                    {canEditCatalog && (
                        <Typography
                            color={(theme) =>
                                alpha(theme.palette.common.black, 0.5)
                            }
                            typography="openSans.body2Medium"
                            sx={{ maxWidth: '280px', textAlign: 'center' }}
                        >
                            {t(
                                'Click on Add new item button to add items to the Inventory',
                            )}
                            .
                        </Typography>
                    )}
                </>
            )}
        </EmptyPlaceholder>
    );
};
